import { FaFacebookF, FaLinkedinIn, FaInstagram, FaTelegramPlane, FaInstagramSquare } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6"
import { AiFillInstagram } from "react-icons/ai";
import { MdEmail } from "react-icons/md";
import { BsWhatsapp } from 'react-icons/bs';

const Icons ={
    FaFacebookF,
    FaLinkedinIn,
    FaXTwitter,
    FaInstagram,
    FaTelegramPlane,
    AiFillInstagram,
    MdEmail,
    BsWhatsapp
}

export default Icons;